import React from 'react';
import { useBilling } from '../../contexts/BillingContext';
import { RangePreset, rangeFor, rangePresets } from '../../utils/billingMoney';
type Props = {
  preset: RangePreset;
  from: string;
  to: string;
  onChange: (next: {
    preset: RangePreset;
    from: string;
    to: string;
  }) => void;
  idPrefix: string;
};

/** Compact preset + custom date range control used on Billing Home and Reports. */
export function DateRangeFilter({
  preset,
  from,
  to,
  onChange,
  idPrefix
}: Props) {
  const {
    config
  } = useBilling();
  const opts = {
    weekStart: config.regional.weekStart,
    fyStartMonth: config.regional.financialYearStartMonth
  };
  return <div className="flex flex-wrap items-end gap-2" data-id="element-3247" data-mp="3nm2x7ev3ppl6">
      <div data-id="element-3248" data-mp="3slp99kz70zse">
        <label htmlFor={`${idPrefix}-preset`} className="block text-[11px] font-medium text-slate-500" data-id="element-3249" data-mp="3smi901zqip11">Period</label>
        <select id={`${idPrefix}-preset`} value={preset} onChange={e => {
        const p = e.target.value as RangePreset;
        onChange(p === 'custom' ? {
          preset: p,
          from,
          to
        } : {
          preset: p,
          ...rangeFor(p, undefined, opts)
        });
      }} className="mt-0.5 rounded-md border border-slate-300 bg-white px-2 py-1.5 text-sm" data-id="element-3250" data-mp="12vlmdpww241o">
          {rangePresets.map(p => <option key={p.id} value={p.id} data-id="element-3251" data-mp="2wae5ovueoiw5">{p.label}</option>)}
        </select>
      </div>
      <div data-id="element-3252" data-mp="2wc8qma5ogb08">
        <label htmlFor={`${idPrefix}-from`} className="block text-[11px] font-medium text-slate-500" data-id="element-3253" data-mp="2rbba020bfp0u">From</label>
        <input id={`${idPrefix}-from`} type="date" value={from} max={to} onChange={e => onChange({
        preset: 'custom',
        from: e.target.value,
        to
      })} className="mt-0.5 rounded-md border border-slate-300 px-2 py-1.5 text-sm" data-id="element-3254" data-mp="2mcrn9zdwe97f" />
      </div>
      <div data-id="element-3255" data-mp="2cn84etq6qfck">
        <label htmlFor={`${idPrefix}-to`} className="block text-[11px] font-medium text-slate-500" data-id="element-3256" data-mp="2cmokj7gz5gvw">To</label>
        <input id={`${idPrefix}-to`} type="date" value={to} min={from} onChange={e => onChange({
        preset: 'custom',
        from,
        to: e.target.value
      })} className="mt-0.5 rounded-md border border-slate-300 px-2 py-1.5 text-sm" data-id="element-3257" data-mp="28iqkmujts21s" />
      </div>
    </div>;
}